import {
  AddChildNodeMenuItem,
  DeleteMenuItem,
  EditMenuItem,
  TreeNodeActions,
  TreeNodeActionsMenu,
} from 'ra-tree-ui-materialui'
import React from 'react'

export const CategoryNodeActions = ({ permissions, ...props }) => {
  const actions = []
  if (permissions?.includes('update:categories')) {
    actions.push(<EditMenuItem />)
  }
  if (permissions?.includes('create:categories')) {
    actions.push(<AddChildNodeMenuItem />)
  }
  if (permissions?.includes('delete:categories')) {
    actions.push(<DeleteMenuItem />)
  }
  if (!actions.length) {
    return null
  }
  return (
    <TreeNodeActions {...props}>
      <TreeNodeActionsMenu>{actions}</TreeNodeActionsMenu>
    </TreeNodeActions>
  )
}
